/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceQueryFieldPresence extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceQueryFieldPresence");
    }

    getFixupPrototypeFunction() { return ResourceQueryFieldPresence.fixupPrototype; }

    static newInstance(model: Partial<ResourceQueryFieldPresence>): ResourceQueryFieldPresence {
        let obj = Object.assign(new ResourceQueryFieldPresence(), model);
        ResourceQueryFieldPresence.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceQueryFieldPresence>): ResourceQueryFieldPresence {
        if (!model) return null;
        return ResourceQueryFieldPresence.newInstance(<ResourceQueryFieldPresence> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceQueryFieldPresence) {
        if (!obj) return;

        models.ResourceQueryFieldPresence.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceQueryFieldPresence): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceQueryFieldPresence.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Field to match.
     */
    field: models.BillingLineItemsOptionalFields;

    /**
     * Matches against resources with or without the given field
     */
    has_field: boolean;

}
